import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { replace as routerReplace } from '@lagunovsky/redux-react-router';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { locationSelector } from '../_selectors/location.selector';
import { RouterAction } from '../router.action';

type IState =
  & IGetSelectorStateType<typeof locationSelector>;

export const replaceEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(RouterAction.replace),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const [to, locationState] = payload;
    const location = locationSelector(state);

    if (typeof to === 'string') {
      return [
        routerReplace({
          ...location,
          pathname: to,
        }, locationState),
      ];
    }

    return [
      routerReplace(to, locationState),
    ];
  }),
);
